import React, { useEffect, useState } from "react";
import { Redirect } from "react-router";
import {
  useActions,
  useActionGroups,
  useAIMethods,
  useAuthenticatedSocket,
  useBlockLibraries,
  useDatasets,
  useDeviceGroups,
  useDevices,
  useDeviceTypes,
  useEmitFetchData,
  useModels,
  usePrograms,
  useUser,
  useWorkers,
  useActionsByBlockLibrary,
  useActionsGroupedByBlockLibrary,
  useNotifications,
  useProducts
} from "../Api/newSockets.api";
import FullLogo from "../assets/images/logo.png";
import Logo from "../assets/images/poweriot-logo.png";
import { useModuleAccess } from "../hooks/useModuleAccess";

const Loading = () => {
  const [fail, setFail] = useState(null);
  const { canAccessPath, landingPath } = useModuleAccess();

  const { devices } = useDevices();
  const { deviceGroups } = useDeviceGroups();
  const { programs } = usePrograms();
  const { actions } = useActions();
  const { products } = useProducts();
  const { actionGroups } = useActionGroups();
  const { datasets } = useDatasets();
  const { models } = useModels();
  const { AIMethods } = useAIMethods();
  const { workers } = useWorkers();
  const { blockLibraries } = useBlockLibraries();
  const { deviceTypes } = useDeviceTypes();
  const { notifications } = useNotifications();
  const { authSocket, connected, error } = useAuthenticatedSocket();
  const { actionsGroupedByBlockLibrary } = useActionsGroupedByBlockLibrary();
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!connected || !authSocket) return;
    authSocket.emit("getDevices");
    authSocket.emit("getDeviceGroups");
    authSocket.emit("getDeviceTypes");
    authSocket.emit("getPrograms");
    authSocket.emit("getActions");
    authSocket.emit("getActionGroups");
    authSocket.emit("getDatasets", {});
    authSocket.emit("getModels");
    authSocket.emit("getAIMethods");
    authSocket.emit("getWorkers");
    authSocket.emit("getDeviceTypes");
    authSocket.emit("getAllBlockLibraries");
    authSocket.emit("getActionsGroupedByBlockLibrary");
    authSocket.emit("getDeviceTypes");
    authSocket.emit("getNotifications");
    authSocket.emit("getProducts");
    authSocket.emit("getUser", {}, (user) => {
      setUser(user)
     });
    // setTimeout(() => {
    //   if (!deviceGroups && !actions) {
    //     setFail("Error occured. Please login again.");
    //     localStorage.clear();
    //   }
    // }, 5000);
  }, [connected]);

  const localUrl = window.localStorage.getItem("URL");
  const url = JSON.parse(localUrl);
  const redirectTarget =
    typeof url === "string" && canAccessPath(url) ? url : landingPath;

  return (
    <div className="loading">
      {devices &&
        deviceGroups &&
          programs &&
          actions &&
          actionGroups &&
          datasets &&
          models &&
          AIMethods &&
          workers &&
          blockLibraries &&
          deviceTypes && (
            user &&
            notifications &&
            products &&
            <Redirect to={redirectTarget} />
          )}
      <div className="loading-container">
        <img className="logo" src={Logo} />
        <img className="logo-full" src={FullLogo} />
        {fail && <span className="title">{fail}</span>}
      </div>
    </div>
  );
};

export default Loading;
